/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var EventTrigger;
(function (EventTrigger) {
    EventTrigger[EventTrigger["EventTriggerAutomate"] = 1] = "EventTriggerAutomate";
    EventTrigger[EventTrigger["EventTriggerUser"] = 2] = "EventTriggerUser";
    EventTrigger[EventTrigger["EventTriggerApi"] = 3] = "EventTriggerApi";
    EventTrigger[EventTrigger["EventTriggerSystem"] = 4] = "EventTriggerSystem";
})(EventTrigger || (EventTrigger = {}));
export var ExportTaskStatus;
(function (ExportTaskStatus) {
    ExportTaskStatus[ExportTaskStatus["ExportTaskStatusInit"] = 0] = "ExportTaskStatusInit";
    ExportTaskStatus[ExportTaskStatus["ExportTaskStatusProcessing"] = 1] = "ExportTaskStatusProcessing";
    ExportTaskStatus[ExportTaskStatus["ExportTaskStatusUploading"] = 2] = "ExportTaskStatusUploading";
    ExportTaskStatus[ExportTaskStatus["ExportTaskStatusFinished"] = 3] = "ExportTaskStatusFinished";
})(ExportTaskStatus || (ExportTaskStatus = {}));
